import { UPDATE_AIRPORT_V2, UPDATE_AIRPORT_V2_SUCCESS, UPDATE_AIRPORT_V2_ERROR, UPDATE_AIRPORT_V2_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateAirportV2 = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AIRPORT_V2:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_AIRPORT_V2_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_AIRPORT_V2_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_AIRPORT_V2_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateAirportV2;
